<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showMerchantDetailPaymentSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="cs-header-title">Detail payment</div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                       [styleClass]="'app-scrollpanel'">

            <div class="payment-title">Nominated Payout Account</div>

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">Payout Account Type</div>
                        <p-dropdown placeholder="Select" [(ngModel)]="payment.PayoutAccountTypeId" [options]="payoutAccountTypes"
                                    optionLabel="name" optionValue="value" [showClear]="true" [disabled]="true"></p-dropdown>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                </div>
            </div>

            <div class="flex flex-row" *ngIf="payment.PayoutAccountTypeId !== undefined && payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">E-Wallet Details</div>
                        <p-dropdown placeholder="Select" [(ngModel)]="payment.WalletDetailId" [options]="walletDetails"
                                    optionLabel="name" optionValue="value" [showClear]="true" [disabled]="true"></p-dropdown>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                </div>
            </div>

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <input type="text" [(ngModel)]="payment.AccountName" placeholder="Account Name" pInputText [disabled]="true" />
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <input type="text" [(ngModel)]="payment.AccountNumber" placeholder="Account Number" pInputText [disabled]="true" />
                    </div>
                </div>
            </div>

            <div *ngIf="!isMerchant">
                <hr />

                <div class="verification-questions-body">
                    <div class="verification-questions-title">
                        Review
                    </div>
                    <div class="verification-questions" *ngFor="let item of questions">
                        <div class="question-column-70">
                            <div class="verification-name">{{item.name}}</div>
                        </div>
                        <div class="question-column-30">
                            <div class="verification-question-switch">
                                <p-inputSwitch [(ngModel)]="item.isChecked" (click)="addOrUpdateMerchantVerificationCheckList(item)"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                    <div class="merchant-form">
                        <div class="merchant-label-reasons">Other reasons</div>
                        <textarea class="textarea-description" rows="5" cols="30" [(ngModel)]="payment.RejectReason" placeholder="Type here..." pInputTextarea></textarea>
                    </div>
                </div>
            </div>
        </p-scrollPanel>

        <div class="flex justify-content-end mrg-10-0px" *ngIf="!isMerchant">
            <button class="red-btn" pButton label="Reject" style="margin-right: 10px;" (click)="approvedOrReject(payoutAccountStatusEnum.Rejected)"></button>
            <button class="green-btn" pButton label="Approve" (click)="approvedOrReject(payoutAccountStatusEnum.Approved)"></button>
        </div>
    </div>

</p-sidebar>